export const withFullTranslationKey = (translationKey?: string): string => `content_policy_reporting:${translationKey}`;
export const removeFullTranslationKey = (value: string): string => value.replace(/content_policy_reporting:/gi, '');
